import { combineEpics } from 'redux-observable';
import { EmailAddressActionTypes, FetchEmailAddresses, AddEmailAddress, EditEmailAddress, ResendPendingConfirmation, CancelPendingEmailAddress, RemoveEmailAddress } from '../actions/EmailAddressActions';
import { getFetchEmailAddressesRequestStatus, getAddEmailAddressRequestStatus, getRemoveEmailAddressRequestStatus, getResendPendingConfirmationRequestStatus, getCancelPendingEmailAddressRequestStatus, getEditEmailAddressRequestStatus } from '../selectors/RequestStatusSelector';
import EmailAddressesAPI from '../api/EmailAddressesAPI';
import RequestStatusTypes from '../constants/RequestStatusTypes';
import RequestEpicDescriptor from './RequestEpicDescriptor';
import requestEntity from './requestEntity';
const fetchEmailAddresses = requestEntity(new RequestEpicDescriptor({
  apiFunction: EmailAddressesAPI.getEmailAddresses,
  initiatingActionType: EmailAddressActionTypes.LOAD_EMAIL_ADDRESSES,
  requestStatusSelector: getFetchEmailAddressesRequestStatus,
  requestStatusTypeFilters: [RequestStatusTypes.UNINITIALIZED, RequestStatusTypes.SUCCEEDED, RequestStatusTypes.FAILED],
  requestActions: FetchEmailAddresses
}));
const addEmailAddress = requestEntity(new RequestEpicDescriptor({
  apiFunction: EmailAddressesAPI.addEmailAddress,
  initiatingActionType: EmailAddressActionTypes.ADD_EMAIL_ADDRESS,
  requestStatusSelector: getAddEmailAddressRequestStatus,
  requestStatusTypeFilters: [RequestStatusTypes.UNINITIALIZED, RequestStatusTypes.SUCCEEDED, RequestStatusTypes.FAILED],
  requestActions: AddEmailAddress,
  alertOnSuccess: true,
  alertOnFailure: false
}));
const editEmailAddress = requestEntity(new RequestEpicDescriptor({
  apiFunction: EmailAddressesAPI.editEmailAddress,
  initiatingActionType: EmailAddressActionTypes.EDIT_EMAIL_ADDRESS,
  requestStatusSelector: getEditEmailAddressRequestStatus,
  requestStatusTypeFilters: [RequestStatusTypes.UNINITIALIZED, RequestStatusTypes.SUCCEEDED, RequestStatusTypes.FAILED],
  requestActions: EditEmailAddress,
  alertOnSuccess: true,
  alertOnFailure: false
}));
const resendPendingConfirmation = requestEntity(new RequestEpicDescriptor({
  apiFunction: EmailAddressesAPI.resendPendingConfirmation,
  initiatingActionType: EmailAddressActionTypes.RESEND_PENDING_CONFIRMATION,
  requestStatusSelector: getResendPendingConfirmationRequestStatus,
  requestStatusTypeFilters: [RequestStatusTypes.UNINITIALIZED, RequestStatusTypes.SUCCEEDED, RequestStatusTypes.FAILED],
  requestActions: ResendPendingConfirmation,
  alertOnSuccess: true,
  alertOnFailure: false
}));
const cancelPendingEmailAddress = requestEntity(new RequestEpicDescriptor({
  apiFunction: EmailAddressesAPI.cancelPendingEmailAddress,
  initiatingActionType: EmailAddressActionTypes.CANCEL_PENDING_EMAIL_ADDRESS,
  requestStatusSelector: getCancelPendingEmailAddressRequestStatus,
  requestStatusTypeFilters: [RequestStatusTypes.UNINITIALIZED, RequestStatusTypes.SUCCEEDED, RequestStatusTypes.FAILED],
  requestActions: CancelPendingEmailAddress,
  alertOnSuccess: true,
  alertOnFailure: false
}));
const removeEmailAddress = requestEntity(new RequestEpicDescriptor({
  apiFunction: EmailAddressesAPI.removeEmailAddress,
  initiatingActionType: EmailAddressActionTypes.REMOVE_EMAIL_ADDRESS,
  requestStatusSelector: getRemoveEmailAddressRequestStatus,
  requestStatusTypeFilters: [RequestStatusTypes.UNINITIALIZED, RequestStatusTypes.SUCCEEDED, RequestStatusTypes.FAILED],
  requestActions: RemoveEmailAddress,
  alertOnSuccess: true,
  alertOnFailure: true
}));
export default combineEpics(fetchEmailAddresses, addEmailAddress, editEmailAddress, cancelPendingEmailAddress, resendPendingConfirmation, removeEmailAddress);